import React from "react";
import { useHistory } from "react-router-dom";

import "./SurveyBlank.styles.scss";
import { Button } from "../../forms";
import { ReactComponent as PlusCircle } from "../../../assets/icons/plus-in-circle-white.svg";
import { IHandleCreateSurvey, useCreateSurveyHook, useDealParamsHooks } from "hooks";
import { DealRoleGuard } from "components/guards";
import { RoleName } from "../../../constants";
import { DealFolderForm } from "store/types";
import { useDealActions } from "store";

export const SurveyBlank: React.FC = () => {
  const { goBack } = useHistory();
  const { dealId, sectionId } = useDealParamsHooks();
  const handleSurveyHook: IHandleCreateSurvey = useCreateSurveyHook();
  const { createFormAction } = useDealActions();

  return (
    <div className="form-blank flex-row-fc-st">
      <div className="content flex-col-fs-fs">
        <Button title="Back" onClick={goBack} />
        <div className="blank flex-col-fc-fc">
          <span className="title">There isn`t any form in this folder</span>
          <DealRoleGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
            <div
              onClick={async () => {
                const data: DealFolderForm = await createFormAction({
                  dealId,
                  sectionId
                });
                handleSurveyHook(data);
              }}
              className="start-btn flex-row-fs-fc scale-click"
            >
              <PlusCircle className="icon" />
              <span>START A NEW TEMPLATE</span>
            </div>
          </DealRoleGuard>
        </div>
      </div>
    </div>
  );
};
